import InvestmentForm from "./InvestmentForm"

export default InvestmentForm
